'use client';
import { type RefObject } from 'react';
import Modal from '@/components/Modal';
import { ICollectableCoupon } from '@/interfaces/collectableCoupon';
import type { GridResult } from '../lib/grid';
import { CollectableCouponSwiper } from './CollectableCouponSwiper';

export interface CollectableCouponsModalProps {
  open: boolean;
  onClose: () => void;
  coupons: ICollectableCoupon[];
  /** True when only a single card is shown (pageSize === 1, mobile). */
  isOneCardLayout: boolean;
  grid: GridResult;
  /** Viewport column tier (1/2/3/4) forwarded to the swiper. */
  pageSize: number;
  pageIndex: number;
  onPageChange: (pageIndex: number) => void;
  swiperRef: RefObject<any>;
  onCollect: (couponId: string) => void;
  isCollecting: boolean;
  collectingId?: string;
}

/**
 * Wraps the project's `<Modal>` with the floating-coupon chrome:
 *   - Mobile (isOneCardLayout): transparent dialog, suppress heading +
 *     built-in close icon, add the card-level close icon instead.
 *   - Tablet / desktop: white dialog with heading + built-in close.
 */
export const CollectableCouponsModal = ({
  open,
  onClose,
  coupons,
  isOneCardLayout,
  grid,
  pageSize,
  pageIndex,
  onPageChange,
  swiperRef,
  onCollect,
  isCollecting,
  collectingId,
}: CollectableCouponsModalProps) => (
  <Modal
    open={open}
    heading={isOneCardLayout ? undefined : 'Available Coupons'}
    closeModal={onClose}
    closeButton={!isOneCardLayout}
    className="w-full"
    dialogClasses={isOneCardLayout ? '!bg-transparent floating-coupon-modal-transparent' : undefined}
    dialogStyles={isOneCardLayout ? { boxShadow: 'none !important' } : undefined}
    bodyClassName={`floating-coupon-body ${isOneCardLayout ? '!overflow-x-visible scrollbar-hide' : ''}`.trim()}
  >
    <CollectableCouponSwiper
      coupons={coupons}
      grid={grid}
      pageSize={pageSize}
      pageIndex={pageIndex}
      onPageChange={onPageChange}
      swiperRef={swiperRef}
      onCollect={onCollect}
      isCollecting={isCollecting}
      collectingId={collectingId}
      showCardCloseIcon={isOneCardLayout}
      onCardClose={onClose}
    />
  </Modal>
);